import { useMemo } from 'react';

import { LiveErrorPage } from '@vimeo/live-core/components/error/page';
import {
  T_ERROR_BECAUSE_OF_PRIVACY_CANNOT_JOIN,
  T_ERROR_COUND_NOT_FIND_INTERACTION_ROOM,
  T_ERROR_NOT_FOUND,
  T_ERROR_REFERRER_NOT_ALLOWED_TO_EMBED,
  T_ERROR_TECHNICAL_DIFFICULTIES,
  T_ERROR_TECHNICAL_DIFFICULTIES_TRY_AGAIN,
} from '@vimeo/live-core/translations';
import { EApiErrorCode } from '@vimeo/live-core/types/error';
import { isApiError } from '@vimeo/live-core/utils/error';

interface IInteractionToolsErrorPageProps {
  error: Error;
}

/**
 * Component for interaction tools scope error handling.
 */
export function InteractionToolsErrorPage({ error }: IInteractionToolsErrorPageProps) {
  const [title, message] = useMemo(() => {
    /**
     * If it is api error containing required code fields.
     */
    if (isApiError(error)) {
      switch (error.data.body.errorCode) {
        case EApiErrorCode.NOT_FOUND:
          return [T_ERROR_NOT_FOUND, T_ERROR_COUND_NOT_FIND_INTERACTION_ROOM];
        case EApiErrorCode.REFERRER_NOT_ALLOWED_TO_EMBED:
          return ['', T_ERROR_REFERRER_NOT_ALLOWED_TO_EMBED];
        case EApiErrorCode.ROOM_AUTHORIZATION_FAILED_AUTH_VALUES_ARE_INVALID:
          return ['', T_ERROR_BECAUSE_OF_PRIVACY_CANNOT_JOIN];
      }
    }

    return [T_ERROR_TECHNICAL_DIFFICULTIES, T_ERROR_TECHNICAL_DIFFICULTIES_TRY_AGAIN];
  }, [error]);

  return <LiveErrorPage title={title} message={message} error={error} isHeaderEnabled={false} />;
}
